import { api } from "../Configurations/axios";

const GetAllByCompanyId = async (companyId: string) => {
    try {
        const result = await api.get(`/Plea/GetAllByCompanyId?companyId=${companyId}`);
        const response = await result.data;
        return response;
      } catch (error: any) {
        throw new Error(error.response.data);
      }
}

const GetPleaByPleaId = async (pleaId: string) => {
    try {
        const result = await api.get(`/Plea/GetByPleaId?pleaId=${pleaId}`);
        const response = await result.data;
        return response;
      } catch (error: any) {
        throw new Error(error.response.data);
      }
}

const GetAllPleaPaginatedAPI = async (companyId: string, page = 1, take = 7, word = "all") => {

  word = word == undefined || word == null ? "all" : word ;
  const result = await api.get(`/Plea/GetAllByCompanyIdPaginated?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
  const response = await result.data;

  return response;
}

const GetAllProjectGroupingByCompany = async (companyId: string) => {
  try {
      const result = await api.get(`/Plea/GetAllProjectGroupingByCompanyId?companyId=${companyId}`);
      const response = await result.data;
      return response;
    } catch (error: any) {
      throw new Error(error.response.data);
    }
}

const CreatePleaAPI = async (companyId: string, projectGroupingId: string, bankName: string, userEmail: string) => {
  try {
      const result = await api.post(`/Plea/Post`, {
          companyId: companyId,
          projectGroupingId: projectGroupingId,
          bankName: bankName,
          userEmail: userEmail
      });

      const response = await result.data;
      return response;
  } catch (error: any) {
      throw new Error(error.response.data);
  }
}

const DeletePleaAPI = async (pleaId: string) => {
  try {
      const result = await api.delete(`/Plea/Delete`, {data: { Id: pleaId}});
      const response = await result.data;
      return response;
  } catch (error: any) {
      throw new Error(error.response.data);
  }
}

export {
    GetAllByCompanyId,
    GetPleaByPleaId,
    GetAllPleaPaginatedAPI,
    GetAllProjectGroupingByCompany,
    CreatePleaAPI,
    DeletePleaAPI
}